// function to generate Business schema
export const generateBusinessSchema = (eventSchema = []) => {
  // Construct the schema object
  let schema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: 'Mepass',
    url: 'https://www.mepass.in',
    logo: 'https://www.mepass.in/apple-touch-icon-192x192.png',
    sameAs: [
      'https://www.facebook.com/mepassbharat',
      'http://linkedin.com/company/mepassbharat',
      'https://x.com/vibewithmepass',
      'https://www.instagram.com/vibewithmepass/',
    ],
    contactPoint: {
      '@type': 'ContactPoint',
      telephone: '+91-9099060633',
      contactType: 'Customer Support',
      email: 'support@mepass.in',
      areaServed: 'IN',
      availableLanguage: ['English'],
    },
    description:
      'Mepass is a digital-first event ticketing platform helping organisers and audiences experience events with ease across India.',
    founder: {
      '@type': 'Person',
      name: 'Neerav Jayswal',
    },
    address: {
      '@type': 'PostalAddress',
      addressLocality: 'Ahmedabad',
      addressRegion: 'Gujarat',
      postalCode: '380015',
      addressCountry: 'IN',
    },
  };

  return schema;
};
